import { createActionConst } from '../../../utils/action.utils';

const QUESTION_NAMESPACE = 'QUESTION';

export const STORE_QUESTION = createActionConst(QUESTION_NAMESPACE, 'STORE_QUESTION');
export const CLEAR_QUESTION = createActionConst(QUESTION_NAMESPACE, 'CLEAR_QUESTION');
